export const SET_MAIL_LIST = "SET_MAIL_LIST";

export const SET_MAIL_TO_LIST = "SET_MAIL_TO_LIST";

export const SET_MAIL_TEMP_LIST = "SET_MAIL_TEMP_LIST";

export const SET_MAIL_LIST_DEFAULT = "SET_MAIL_LIST_DEFAULT";

export const SET_ADDRESS_LIST = "SET_ADDRESS_LIST";
